import React from "react";
import SignupForm from "@/components/auth/SignupForm";

const SignupOperator: React.FC = () => (
  <div className="py-8 flex flex-col items-center">
    <h2 className="text-3xl font-bold text-sauna-navy mb-2">Sign Up as an Operator</h2>
    <p className="text-sauna-navy/70 mb-6 text-lg text-center max-w-md">Register your sauna business and manage your bookings with SaunaDip.</p>
    <SignupForm role="operator" />
  </div>
);

export default SignupOperator; 